import React from "react";
import { MapPin, Phone, Star } from "lucide-react";
import { NAV_LINKS, BUSINESS } from "../data";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 bg-black/50">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div className="lg:col-span-2">
          <a href="#home" data-testid="footer-logo" className="font-display text-2xl font-black tracking-tighter text-white">
            MEGA<span className="text-neon">WIN</span>5K
          </a>
          <p className="mt-5 max-w-sm text-sm text-white/60 leading-relaxed">
            A game store and gaming destination in {BUSINESS.region}. Come play,
            unwind, and enjoy the experience.
          </p>
          <a
            href={BUSINESS.reviewsLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-reviews-link"
            className="mt-6 inline-flex items-center gap-2 text-sm text-white/70 hover:text-neon transition-colors duration-200"
          >
            <Star size={15} className="text-neon fill-neon" /> {BUSINESS.reviews} Google reviews
          </a>
        </div>

        <div>
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-white/40">Explore</p>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-sm text-white/60 hover:text-neon transition-colors duration-200"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-white/40">Contact</p>
          <ul className="mt-5 space-y-4 text-sm text-white/60">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-neon shrink-0 mt-0.5" />
              <span>{BUSINESS.addressFull}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-neon shrink-0" />
              <a
                href={BUSINESS.callLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-phone-link"
                className="hover:text-neon transition-colors duration-200"
              >
                {BUSINESS.phoneDisplay}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-white/40">
          © {new Date().getFullYear()} MEGAWIN5K. All rights reserved.
        </p>
        <p className="text-xs text-white/40">
          Game Store · {BUSINESS.addressLine}, Indonesia
        </p>
      </div>
    </div>
  </footer>
);
